import { useHistory } from 'react-router-dom';

const useHistoryRedirect = () => {
  const history = useHistory();
  return history?.location?.state?.redirectUrl;
};

export default useHistoryRedirect;
